<template>
  <!--  会员专享8大特权介绍  -->
  <div class="privilege-box">
    <div class="inner_center">
      <h2>会员专享8大特权介绍</h2>
      <div class="privilege-content">
        <div
          v-for="(vo,idx) in privilegeList"
          :key="'privilege'+idx"
          class="privilege-item"
        >
          <i :class="'icon_'+ (idx+1)"/>
          <span class="name">{{ vo }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {privilegeList} from "@/components/introduce/common/module";
export default {
  name: "IntroPrivilege",
  data() {
    return {
      privilegeList
    }
  }
}
</script>

<style lang="scss" scoped>
.privilege-box {
  height: 733px;
  padding-top: 100px;
  h2{
    font-size: 36px;
    font-weight: bold;
    color: #2D2B33;
    line-height: 48px;
    letter-spacing: 1px;
    text-align: center;
    padding: 325px 0 64px;
  }


  .privilege-content {
    display: flex;
    flex-wrap: wrap;

    .privilege-item {
      width: 300px;
      height: 96px;
      background: #FFFFFF;
      border-radius: 1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 64px;

      i {
        margin-bottom: 16px;

        &.icon_1{
          @include BgImage2(56px,56px,'introduce/01.png');
        }
        &.icon_2{
          @include BgImage2(56px,56px,'introduce/02.png');
        }
        &.icon_3{
          @include BgImage2(56px,56px,'introduce/03.png');
        }
        &.icon_4{
          @include BgImage2(56px,56px,'introduce/04.png');
        }
        &.icon_5{
          @include BgImage2(56px,56px,'introduce/05.png');
        }
        &.icon_6{
          @include BgImage2(56px,56px,'introduce/06.png');
        }
        &.icon_7{
          @include BgImage2(56px,56px,'introduce/07.png');
        }
        &.icon_8{
          @include BgImage2(56px,56px,'introduce/08.png');
        }

      }
      .name{
        font-size: 18px;
        font-weight: bold;
        color: #0A2540;
        line-height: 24px;
        letter-spacing: 1px;
      }
    }
  }

}
</style>
